module.exports = __webpack_public_path__ + "static/media/icon-square.48de18ef.svg";